module.exports = __webpack_public_path__ + "static/img/bg.b20d8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purchase/bg.png
// module id = oeAn
// module chunks = 1